import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchPackageLearningById } from '../api/api'; // Giả sử dùng hàm này
import { Package, PackageLearning } from '../types';
import TopicCard from '../components/TopicCard';
import EmptyState from '../components/EmptyState';

function TopicsPage() {
  const { packageId } = useParams<{ packageId: string }>();
  const [pkg, setPkg] = useState<PackageLearning | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const navigate2 = useNavigate();

  // State mới để quản lý chế độ xem
  const [viewMode, setViewMode] = useState<'grid' | 'list'>(() => {
    const savedView = localStorage.getItem('viewMode') as 'grid' | 'list';
    return savedView || 'grid'; // Dùng giá trị đã lưu, nếu không có thì mặc định là 'grid'
  });


  useEffect(() => {
    localStorage.setItem('viewMode', viewMode);
  }, [viewMode]);

  useEffect(() => {
    if (packageId) {
      const getPackageData = async () => {
        setLoading(true);
        try {
          const data = await fetchPackageLearningById(packageId); // Dùng lại hàm fetch package
          setPkg(data || null);
        } catch (error) {
          console.error("Failed to fetch package:", error);
          setPkg(null);
        } finally {
          setLoading(false);
        }
      };
      getPackageData();
    }
  }, [packageId]);

  if (loading) {
    return <div>Loading topics...</div>;
  }

  if (!pkg) {
    return <div>Learning package not found.</div>;
  }

  return (
    <div>
      <div className="page-header">
        <button onClick={() => navigate(-1)} className="btn-back">
          ‹ Back
        </button>
        <div className="topic-title">
          {/* <p>Package</p> */}
          <h2>{pkg.name}</h2>
        </div>
      </div>

      {/* Bộ chuyển đổi chế độ xem */}
      <div className="view-toggle glass-effect">
        <button className={viewMode === 'grid' ? 'active' : ''} onClick={() => setViewMode('grid')}>Grid</button>
        <button className={viewMode === 'list' ? 'active' : ''} onClick={() => setViewMode('list')}>List</button>
      </div>

      {/* Container sẽ có class động */}
      <div className={viewMode === 'grid' ? 'topics-grid' : 'topics-list'}>
        {pkg.topics && pkg.topics.map(topic => (
          <TopicCard key={topic.id} topic={topic} />
        ))}
      </div>

      {(!pkg.topics || pkg.topics.length === 0) && (
        <EmptyState
          title="This Package is Empty"
          message="Get started by creating the first topic. You can do this in the Content Studio."
          action={
            <button onClick={() => navigate2(-1)} className="btn btn-primary">
              ‹ Go Back
            </button>
          }
        />
      )}
    </div>
  );
}

export default TopicsPage;